import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

import { GlobalStyle } from "./theme/GlobalStyle";
import { Layout } from "./components/layout/Layout";

import { Landing } from "./pages/Landing";
import { Invest } from "./pages/Invest";
import { Borrow } from "./pages/Borrow";
import { Products } from "./pages/Products";
import { Software } from "./pages/Software";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Terms, Privacy, Compliance } from "./pages/Legal";

export default function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/invest" element={<Invest />} />
          <Route path="/borrow" element={<Borrow />} />
          <Route path="/products" element={<Products />} />
          <Route path="/software" element={<Software />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  );
}
